var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'underscore', 'underscore.string', 'app-common/ajax-helper', 'app-common/global-storage', 'common/config', 'collection/base'], function($, _, _s, ajaxHelper, globalStorage, TEN_SHEET, BaseCollection) {
  var Core, SplitFactory, core;
  SplitFactory = require('@splitsoftware/splitio').SplitFactory;
  Core = (function() {

    function Core() {
      this.pageRouter = null;
      this.currentClientId = null;
      this.currentClientCurrencyId = null;
      this.currentClientRoles = [];
      this.config = TEN_SHEET["default"] != null ? TEN_SHEET["default"] : null;
      this.metadataEarliest = {};
      this.hasTransactions = true;
      this.collections = {};
      this.models = {};
      this.defaultCurrency = null;
      this.defaultLedgers = {};
      this.reportingIntervalStorageKey = null;
      this.featureFlagClient = null;
    }

    Core.prototype.userHasRole = function(role) {
      return __indexOf.call(this.currentClientRoles, role) >= 0;
    };

    Core.prototype.setMetadataEarliest = function(response) {
      try {
        this.metadataEarliest = response[0] || {};
        if (this.metadataEarliest.transaction === null) {
          this.metadataEarliest.transaction = new Date().getTime();
          return this.hasTransactions = false;
        }
      } catch (e) {

      }
    };

    Core.prototype.setCurrentUserId = function(userId) {
      return this.currentUserId = userId;
    };

    Core.prototype.findDefaultCurrency = function() {
      return this.defaultCurrency = _.findWhere(this.collections.currencies.toJSON(), {
        id: this.currentClientCurrencyId
      });
    };

    Core.prototype.findDefaultLedgers = function() {
      var ledger, _i, _len, _ref, _results;
      _ref = this.collections.ledgerAccounts.toJSON();
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        ledger = _ref[_i];
        switch (ledger.code) {
          case '4500':
            _results.push(this.defaultLedgers['pending.category.revenue'] = ledger);
            break;
          case '5680':
            _results.push(this.defaultLedgers['pending.category.expense'] = ledger);
            break;
          case '5720':
            _results.push(this.defaultLedgers['misc.exp'] = ledger);
            break;
          case '4510':
            _results.push(this.defaultLedgers['misc.rev'] = ledger);
            break;
          case '1560':
            _results.push(this.defaultLedgers['tax.recover'] = ledger);
            break;
          case '1570':
            _results.push(this.defaultLedgers['tax.recover.meals'] = ledger);
            break;
          case '2310':
            _results.push(this.defaultLedgers['tax.payable'] = ledger);
            break;
          case '5300':
            _results.push(this.defaultLedgers['meals'] = ledger);
            break;
          case '1999':
            _results.push(this.defaultLedgers['money.in.transit'] = ledger);
            break;
          case '1998':
            _results.push(this.defaultLedgers['money.in.transit.outstanding'] = ledger);
            break;
          case '4600':
            _results.push(this.defaultLedgers['cogs'] = ledger);
            break;
          default:
            _results.push(void 0);
        }
      }
      return _results;
    };

    Core.prototype.showBench20Banner = function() {
      var banner, bannerHeight, clientInterfaceUrl, menu, newTop, oldTop;
      banner = '.version-2-banner';
      $(banner).show();
      bannerHeight = $(banner).outerHeight();
      menu = '.menu-wrapper';
      oldTop = parseInt($(menu).css('top'));
      newTop = oldTop + bannerHeight;
      $(menu).css('top', newTop);
      clientInterfaceUrl = _.template(this.config.clientInterfaceUrlTemplate, {
        clientId: this.currentClientId
      });
      return $("" + banner + " .btn").attr('href', clientInterfaceUrl).attr('target', '_blank');
    };

    Core.prototype.setRouter = function(router) {
      return this.pageRouter = router;
    };

    Core.prototype.getRouter = function() {
      return this.pageRouter;
    };

    Core.prototype.bootstrap = function(clientId, nonImpersonatedRole, callback) {
      var apiCall, promise, timeoutWarning,
        _this = this;
      apiCall = require('app-common/component/api-call');
      this.inboxEvents = require('app-common/component/inbox-events');
      timeoutWarning = require('app-common/component/timeout-warning');
      clientId = clientId.toString();
      this.currentClientId = clientId;
      this.reportingIntervalStorageKey = 'reportingInterval' + clientId;
      this.models.client = new (require('model/client'))({
        id: this.currentClientId
      });
      this.models.clientsettings = new (require('model/clientsettings'))({
        id: this.currentClientId
      });
      this.initializeFeatureFlagClient();
      timeoutWarning.init();
      promise = Promise.all([this.models.client.fetch(), this.models.clientsettings.fetch()]);
      return promise.then(function() {
        var calls, deferred, role, _i, _len, _ref, _ref1;
        _this.currentClientCurrencyId = _this.models.client.get('currencyId');
        _this.currentClientRoles = _.clone(_this.models.client.get('roles'));
        if (_this.currentUserId != null) {
          _this._createAndFetchCurrentUser();
        }
        if (nonImpersonatedRole && __indexOf.call(_this.currentClientRoles, nonImpersonatedRole) < 0) {
          _this.currentClientRoles.push(nonImpersonatedRole);
        }
        _ref = _this.currentClientRoles;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          role = _ref[_i];
          $('body').addClass("role-" + (role.toLowerCase()));
        }
        ajaxHelper({
          useImpersonation: _this.isCurrentClientBookkeeper(),
          currentClientId: _this.currentClientId
        });
        _this.models.address = new (require('model/address'))({
          id: _this.models.client.get('address').shippingAddressId
        });
        _this.collections.addOn = new (require('collection/addon'));
        _this.collections.currencies = new (require('collection/cached-currency'));
        _this.collections.countries = new (require('collection/cached-country'));
        _this.collections.regions = new (require('collection/cached-region'));
        _this.collections.exchangerates = new (require('collection/exchangerate'))(_this.currentClientCurrencyId);
        _this.collections.ledgerAccounts = new (require('collection/ledger-account'));
        _this.collections.ledgerAccountCategories = new (require('collection/cached-ledger-account-category'));
        _this.collections.categorizerRules = new (require('collection/categorizer-rule'));
        _this.collections.documentRequests = new (require('collection/document-requests'));
        if (_this.isCurrentClientBookkeeper()) {
          _this.initAngular();
        }
        if (_this.isCurrentClientBookkeeper()) {
          _this.collections.ledgerAccountCategoryOrders = new (require('collection/ledger-account-category-order'));
        }
        calls = [apiCall('client', _this.currentClientId + '/metadata_earliest'), _this.inboxEvents.init(), _this.models.address.fetch(), _this.collections.addOn.fetch(), _this.collections.currencies.fetch(), _this.collections.countries.fetch(), _this.collections.regions.fetch(), _this.collections.exchangerates.fetch(), _this.collections.ledgerAccounts.fetch(), _this.collections.ledgerAccountCategories.fetch(), _this.collections.documentRequests.fetch(), (_ref1 = _this.collections.ledgerAccountCategoryOrders) != null ? _ref1.fetch() : void 0];
        deferred = _.map(_.compact(calls), function(call) {
          deferred = $.Deferred();
          call.always(deferred.resolve);
          return deferred;
        });
        return $.when.apply($, deferred).always(function(metadataEarliestResponse) {
          _this.setMetadataEarliest(metadataEarliestResponse);
          _this.findDefaultCurrency();
          _this.findDefaultLedgers();
          if (_.isFunction(callback)) {
            return callback();
          }
        });
      });
    };

    Core.prototype.initClientsEvents = function(el) {
      var ClientsEvents, clientsEvents;
      ClientsEvents = require('app-common/component/clients-events');
      clientsEvents = new ClientsEvents({
        el: el
      });
      clientsEvents.show(this.currentClientId, this.currentClientRoles);
      this.inboxEvents.refreshEventCounters();
      return this.showBench20Banner();
    };

    Core.prototype.getCollection = function(name) {
      return this.collections[name];
    };

    Core.prototype.getModel = function(name) {
      return this.models[name];
    };

    Core.prototype.getCurrentClient = function() {
      return this.models.client;
    };

    Core.prototype.getCurrentClientId = function() {
      return this.currentClientId;
    };

    Core.prototype._createAndFetchCurrentUser = function(options) {
      var PersonModel;
      if (options == null) {
        options = {};
      }
      PersonModel = require('app-common/model/person');
      this._currentUserModel = new PersonModel({
        id: this.currentUserId
      });
      this._currentUserModel.fetch(options);
      return this._currentUserModel;
    };

    Core.prototype.getCurrentUser = function() {
      var _this = this;
      if (this._currentUserModel != null) {
        return this._currentUserModel;
      }
      return this._createAndFetchCurrentUser({
        error: function() {
          return _this._currentUserModel = null;
        }
      });
    };

    Core.prototype.getCurrentUserid = function() {
      return this.currentUserId;
    };

    Core.prototype.getCurrentClientCurrencyId = function() {
      return this.currentClientCurrencyId;
    };

    Core.prototype.getCurrentClientRoles = function() {
      return this.currentClientRoles;
    };

    Core.prototype.initializeFeatureFlagClient = function() {
      var _ref, _ref1, _ref2;
      if (!((_ref = window.BENCH) != null ? (_ref1 = _ref.vendor) != null ? (_ref2 = _ref1.split) != null ? _ref2.authorizationKey : void 0 : void 0 : void 0)) {
        return;
      }
      return this.featureFlagClient = SplitFactory({
        core: {
          authorizationKey: window.BENCH.vendor.split.authorizationKey,
          key: this.currentClientId
        }
      }).client();
    };

    Core.prototype.getFeatureFlagClient = function() {
      return this.featureFlagClient;
    };

    Core.prototype.getLedgerAccountCategoryOrders = function() {
      return this.collections.ledgerAccountCategoryOrders.toJSON();
    };

    Core.prototype.isCurrentClientBookkeeper = function() {
      return (this.userHasRole('USER')) || (this.userHasRole('SALES')) || (this.userHasRole('MANAGER'));
    };

    Core.prototype.saveCurrentInterval = function(currentInterval) {
      return globalStorage.set(this.reportingIntervalStorageKey, currentInterval);
    };

    Core.prototype.loadCurrentInterval = function() {
      return globalStorage.get(this.reportingIntervalStorageKey);
    };

    Core.prototype.getEarliestTransactionTime = function() {
      return this.metadataEarliest.transaction;
    };

    Core.prototype.getEarliestStatementTime = function() {
      return this.metadataEarliest.statement;
    };

    Core.prototype.getEarliestDocumentTime = function() {
      return this.metadataEarliest.document;
    };

    Core.prototype.getEarliestUnmatchedReceiptTime = function() {
      return this.metadataEarliest.unmatched_receipt;
    };

    Core.prototype.hasTransactions = function() {
      return this.hasTransactions;
    };

    Core.prototype.getFeatureFlags = function() {
      var _ref, _ref1;
      return ((_ref = this.getModel('clientsettings')) != null ? (_ref1 = _ref.toJSON()) != null ? _ref1.features : void 0 : void 0) || {};
    };

    Core.prototype.getFeatureFlagValue = function(feature) {
      var features;
      features = this.models.clientsettings.get('features');
      return !(feature in features) || features[feature];
    };

    Core.prototype.isFeatureEnabled = function(featureName) {
      var attributes, bookkeepers, currentClient, featureFlagClient, treatment, _ref, _ref1, _ref2, _ref3;
      featureFlagClient = this.getFeatureFlagClient();
      if (!featureFlagClient) {
        return false;
      }
      currentClient = this.getCurrentClient();
      bookkeepers = (currentClient != null ? (_ref = currentClient.get('assignedPersons')) != null ? _ref.bookkeepers : void 0 : void 0) || {};
      attributes = {
        id: this.getCurrentClientId(),
        bookkeeperId: (_ref1 = bookkeepers.primary) != null ? _ref1.id : void 0,
        secondaryBookkeeperId: (_ref2 = bookkeepers.secondary) != null ? _ref2.id : void 0,
        tertiaryBookkeeperId: (_ref3 = bookkeepers.tertiary) != null ? _ref3.id : void 0
      };
      treatment = featureFlagClient.getTreatmentsWithConfig([featureName], attributes);
      return treatment[featureName].treatment === 'on';
    };

    Core.prototype.getConfig = function() {
      return this.config;
    };

    Core.prototype.getDefaultLedgers = function() {
      return this.defaultLedgers;
    };

    Core.prototype.getLedgersById = function() {
      var ledger, ledgers, ledgersById, _i, _len;
      ledgersById = {};
      ledgers = this.collections.ledgerAccounts.toJSON();
      for (_i = 0, _len = ledgers.length; _i < _len; _i++) {
        ledger = ledgers[_i];
        ledgersById[ledger.id] = ledger;
      }
      return ledgersById;
    };

    Core.prototype.getDefaultCurrency = function() {
      return this.defaultCurrency;
    };

    Core.prototype.isMac = function() {
      return navigator.platform.toLowerCase().indexOf('mac') !== -1;
    };

    Core.prototype.formatMonth = function(month) {
      return _s.pad(parseInt(month) + 1, 2, '0');
    };

    Core.prototype.formatDate = function(date) {
      return date.toString('MM/dd/yyyy');
    };

    Core.prototype.isNumber = function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    };

    Core.prototype.formatYearCorrectly = function(value) {
      if (this.isNumber(value) && value.length === 6) {
        return value.slice(0, 4) + '20' + value.slice(4, 6);
      } else {
        return value;
      }
    };

    Core.prototype.getImpersonatedURL = function(clientId, url) {
      var urlend;
      urlend = url != null ? '/' + url : '';
      return "/app/" + clientId + urlend;
    };

    Core.prototype.isImpersonating = true;

    Core.prototype.getRoleForTracking = function() {
      switch (false) {
        case !this.userHasRole('USER'):
          return 'USER';
        case !this.userHasRole('SALES'):
          return 'SALES';
        case !this.userHasRole('TAX_ACCOUNTANT'):
          return 'TAX_ACCOUNTANT';
        case !this.userHasRole('DEMO_CLIENT'):
          return 'CLIENT';
        case !this.userHasRole('UNPAID_CLIENT'):
          return 'CLIENT';
        default:
          return 'CLIENT';
      }
    };

    Core.prototype.trackEvent = function(eventName, properties) {
      var context, _ref;
      if (properties == null) {
        properties = {};
      }
      if (this.getRoleForTracking() !== 'CLIENT') {
        properties.impersonated_client_id = this.getCurrentClientId();
      }
      context = this.pageRouter.parseLink(this.pageRouter.extractPageUrl())[0];
      if (context != null) {
        properties.context = context;
      }
      return (_ref = window.analytics) != null ? _ref.track(eventName, properties) : void 0;
    };

    Core.prototype.decodeSearchString = function(searchString) {
      var decodedSearchString;
      decodedSearchString = (function() {
        try {
          return decodeURIComponent(searchString);
        } catch (e) {
          return searchString;
        }
      })();
      return decodedSearchString || '';
    };

    Core.prototype.initAngular = function() {
      var clientId,
        _this = this;
      clientId = this.getCurrentClientId();
      return angular.module('bench.main-app', []).constant('MainAppConfig', {
        routes: {
          'bench.dms': '/new-folders',
          'bench.details': '/details',
          'bench.categorizer': '/categorizer-rules',
          'bench.messaging': '/new-dashboard',
          'bench.accounts': '/accounts',
          'bench.ledgers': '/new-ledgers',
          'bench.reviewtool': '/review-tool',
          'bench.generalledger': '/general-ledger',
          'bench.transactionmanager': '/transaction-manager'
        },
        clientId: clientId
      }).config(function($stateProvider) {
        $stateProvider.state('reconciliation', {
          url: "/app/" + clientId + "/reconciliation/:accStatementId",
          template: '',
          onEnter: function($stateParams) {
            if (_this.getRouter().getCurrentPageState().id !== 'reconciliation') {
              return _this.getRouter().loadPage('reconciliation', [$stateParams.accStatementId]);
            }
          }
        });
        return $stateProvider.state('document-entry', {
          url: "/app/" + clientId + "/document-entry/:documentId/:navigationMode?:type",
          template: '',
          onEnter: function($stateParams) {
            var options, params;
            params = [$stateParams.documentId, $stateParams.navigationMode];
            options = $stateParams.type === 'custom' ? {
              queryVals: {
                type: $stateParams.type
              }
            } : {};
            if (_this.getRouter().getCurrentPageState().id !== 'document-entry') {
              return _this.getRouter().loadPage('document-entry', params, options);
            }
          }
        });
      }).run(function($rootScope) {
        var stateToWidgetId;
        stateToWidgetId = {
          'bench.dms': 'new-folders',
          'bench.details': 'details',
          'bench.categorizer': 'categorizer-rules',
          'bench.messaging': 'new-dashboard',
          'bench.accounts': 'accounts',
          'bench.ledgers': 'new-ledgers',
          'bench.reviewtool': 'review-tool',
          'bench.generalledger': 'general-ledger',
          'bench.transactionmanager': 'transaction-manager'
        };
        return $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
          var getBaseStateName, goToState, router;
          getBaseStateName = function(state) {
            return state.match(/[\w\d]+\.[\w\d]+/);
          };
          goToState = stateToWidgetId[getBaseStateName(toState.name)];
          if (goToState == null) {
            return;
          }
          router = _this.getRouter();
          return router.loadPage(goToState, toParams);
        });
      }).run(function($rootScope, MainappActions) {
        return $rootScope.$on(MainappActions.ledgerChanged(), function() {
          return this.collections.ledgerAccounts.fetch();
        });
      });
    };

    return Core;

  })();
  return core = new Core();
});
